import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { routeNames } from '../../routes'
import { setActiveFilterTab } from '../../store/modules/filteredSearch.module'
import topFilterIcon from '../../assets/icons/top-filter-icon.svg'
import moreFiltersIcon from '../../assets/icons/more-filters-icon.svg'
import resultsIcon from '../../assets/icons/filtered-search-results.svg'
import './FilteredSearchSidebar.sass'


class FilteredSearchSidebar extends Component {
  constructor() {
    super()
  }

  buildFilterPrintQueryString = () => {
    const { activeFilterIds }  = this.props

    if (!activeFilterIds.length) {
      return ''
    }

    return "?" + activeFilterIds.map(id => `id=${id}`).join('&')
  }

  render() {
    const { activeTabIdx } = this.props

    return (
      <section className="filtered-search-sidebar">
        <Link className="btn-blue-solid-sm" to={routeNames.guidedSearch}>guide my search</Link>
        <div className="filter-tabs">
          <button
            type="button"
            aria-label="show top filters"
            className={`filter-tab ${activeTabIdx === 0 ? 'is-active-tab' : ''}`}
            onClick={() => this.props.setActiveFilterTab(0)}
          >
            <img className="filter-tab-icon" src={topFilterIcon} alt="top filters" />
            <div className="filter-tab-label">
              <div>change</div>
              <div>top filters</div>
            </div>
          </button>
          <button
            type="button"
            aria-label="show more filters"
            className={`filter-tab ${activeTabIdx === 1 ? 'is-active-tab' : ''}`}
            onClick={() => this.props.setActiveFilterTab(1)}
          >
            <img className="filter-tab-icon" src={moreFiltersIcon} alt="more filters" />
            <div className="filter-tab-label">
              <div>change</div>
              <div>more filters</div>
            </div>
          </button>
          <button
            type="button"
            aria-label="show results"
            className={`filter-tab ${activeTabIdx === 2 ? 'is-active-tab' : ''}`}
            onClick={() => this.props.setActiveFilterTab(2)}
          >
            <img className="filter-tab-icon" src={resultsIcon} alt="results" />
            <div className="filter-tab-label">results</div>
          </button>
        </div>
        <a
          className="btn-blue-solid-sm"
          href={routeNames.filterPrint + this.buildFilterPrintQueryString()}
          target="_blank"
        >
          list selected filters
        </a>
      </section>
    );
  }
}

FilteredSearchSidebar.propTypes = {
  activeTabIdx: PropTypes.number,
  activeFilterIds: PropTypes.array,
}

const mapStateToProps = state => ({
  activeTabIdx: state.filteredSearch.activeTabIdx,
  activeFilterIds: state.filters.activeFilterIds,
})

export default connect(
  mapStateToProps,
  { setActiveFilterTab }
)(FilteredSearchSidebar);
